/** The shell: fixed sidebar, sticky header, routed page content, and the Submit an idea dialog. */

import { Outlet } from 'react-router-dom';

import { SubmitIdeaProvider } from '@/routes/business-opportunities/SubmitIdeaDialog';
import { PAGE_TITLE_ID, PageHeadSlotProvider } from '@/ui/PageHead';

import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { useNavCollapse } from './useNavCollapse';

export function AppShell() {
  const { collapsed, toggle } = useNavCollapse();
  return (
    <SubmitIdeaProvider>
      <div className="app">
        <Sidebar collapsed={collapsed} onToggle={toggle} />
        <PageHeadSlotProvider>
          <div className="app-main">
            <Header />
            <main className="page" aria-labelledby={PAGE_TITLE_ID}>
              <Outlet />
            </main>
          </div>
        </PageHeadSlotProvider>
      </div>
    </SubmitIdeaProvider>
  );
}
